export const FILTER_PRODUCTS = 'FILTER_PRODUCTS';

export const ADD_REQUESTS_LEFT_TO_LOAD = 'ADD_REQUESTS_LEFT_TO_LOAD';
export const REMOVE_REQUESTS_LEFT_TO_LOAD = 'REMOVE_REQUESTS_LEFT_TO_LOAD';

export const DELETE_RESOURCE_SUCCESS = 'DELETE_RESOURCE_SUCCESS';
export const ADD_RESOURCE_SUCCESS = 'ADD_RESOURCE_SUCCESS';
export const UPDATE_RESOURCE_SUCCESS = 'UPDATE_RESOURCE_SUCCESS';
export const GET_ALL_RESOURCES_SUCCESS = 'GET_ALL_RESOURCES_SUCCESS';
export const BATCH_UPDATE_AFTER_GET_ALL_RESOURCES = 'BATCH_UPDATE_AFTER_GET_ALL_RESOURCES';
export const GET_DOWNLOAD_RESOURCES_SUCCESS = 'GET_DOWNLOAD_RESOURCES_SUCCESS';
export const UPLOAD_RESOURCE_SUCCESS = 'UPLOAD_RESOURCE_SUCCESS';
export const GET_RECENT_ORDERS_SUCCESS = 'GET_RECENT_ORDERS_SUCCESS';
export const GET_SEARCHED_USERS_SUCCESS = 'GET_SEARCHED_USERS_SUCCESS';

export const DELETE_RESOURCE_REQUESTED = 'DELETE_RESOURCE_REQUESTED';
export const ADD_RESOURCE_REQUESTED = 'ADD_RESOURCE_REQUESTED';
export const UPDATE_RESOURCE_REQUESTED = 'UPDATE_RESOURCE_REQUESTED';
export const GET_ALL_RESOURCES_REQUESTED = 'GET_ALL_RESOURCES_REQUESTED';
export const GET_HOME_ANALYTICS_REQUESTED = 'GET_HOME_ANALYTICS_REQUESTED';
export const GET_DOWNLOAD_RESOURCE_REQUESTED = 'GET_DOWNLOAD_RESOURCE_REQUESTED';
export const UPLOAD_RESOURCE_REQUESTED = 'UPLOAD_RESOURCE_REQUESTED';
export const GET_RECENT_ORDERS_REQUESTED = 'GET_RECENT_ORDERS_REQUESTED';
export const GET_SEARCHED_USERS_REQUESTED = 'GET_SEARCHED_USERS_REQUESTED';

export const VIEW_MORE_RESOURCE_REQUESTED = 'VIEW_MORE_RESOURCE_REQUESTED';
export const VIEW_MORE_RESOURCE_SUCCESS = 'VIEW_MORE_RESOURCE_SUCCESS';

export const VERIFY_RECOVERY_TOKEN_SUCCESS = 'VERIFY_RECOVERY_TOKEN_SUCCESS';
export const GET_RECOVERY_TOKEN_SUCCESS = 'GET_RECOVERY_TOKEN_SUCCESS';
export const CONFIRM_RESET_PASSWORD_SUCCESS = 'CONFIRM_RESET_PASSWORD_SUCCESS';

export const SEND_PUSH_NOTIFICATION = 'SEND_PUSH_NOTIFICATION';
export const SEND_PUSH_NOTIFICATION_SUCCESS = 'SEND_PUSH_NOTIFICATION_SUCCESS';

export const UPDATE_PAGE_SETTINGS = 'UPDATE_PAGE_SETTINGS';

export const REPRINT_ORDER_REQUESTED = 'REPRINT_ORDER_REQUESTED';
export const REPRINT_ORDER_SUCCESS = 'REPRINT_ORDER_SUCCESS';
export const REPRINT_ORDER_FAILURE = 'REPRINT_ORDER_FAILURE';

export const SET_MODIFIERS_ON_OPTIONS_REQUESTED = 'SET_MODIFIERS_ON_OPTIONS_REQUESTED';
export const SET_EXISTING_OPTIONS_ON_MODIFIER = 'SET_EXISTING_OPTIONS_ON_MODIFIER';
